<res-base-modal [modalTitle]="'End User License Agreement'" [modalClass]="modalClass"
    [modalAutomationId]="modalAutomationId" (closeButtonActionEmt)="closeModal()" [secondaryButtonLabel]="'Close'"
    [isPrimaryButtonHidden]="true" [modalDraggable]="false">

    <div class="eula">
        <h4 class="title">TransPerfect End User License Agreement</h4>
        <br />
        <span>
            This End User License Agreement (the <span class="bold">“EULA”</span>) is between You and TransPerfect Legal
            Solutions, Inc. (<span class="bold">“TransPerfect”</span>) and governs Your use of Reef ECA, Reef Express
            and/or Reef Review (collectively and individually, the <span class="bold">“Software”</span>).
        </span>
        <br /> <br />
        <h4 class="section">Section 1. Delivery and Acceptance</h4>
        <br />
        <span>
            The Software is deemed to be delivered and accepted by You on the date it is
            made available for download, access, or installation.
            <span class="bold">You agree to be bound by the terms of this EULA from the acceptance date. If You do not
                have the authority to enter into this EULA or You do not agree to with its terms, do not use the
                Software.
            </span>
        </span>
        <br /> <br />
        <h4 class="section">Section 2. License</h4>
        <br />
        <span>
            Subject to Your purchase of a license to the Software and compliance with this
            EULA, TransPerfect grants You a non-exclusive and non-transferable license to
            use the Software and related Documentation for Your internal use only in accordance
            with and for the term (if any) specified in any applicable Master Services Agreement,
            Statement of Work, or other agreement to license the Software (“Order”). Certain
            Software licensed may also require the purchase of a separate server license to use the
            Software on certain types of servers, in each case as specified in the Documentation. This
            Software is licensed based on “User Objects,” or Unique UNC Path, and Unique DM
            Path or Repository, meaning a single physical person represented by a User Object
            (or any class of object that is similar) in any type of computer-based directory
            system—i.e., LDAP, Active Directory, and E-Directory. Multiple User objects that
            represent the same physical person within a single directory system DO NOT count as
            one User. The nature of the Software is that it performs a variety of management and
            automation actions that benefit end users (physical persons), even if those Users do not
            directly use the Software. You must acquire a User Object license for each User that
            either a) makes use of, has data stored by, or has access rights to any element of
            storage or indexes that is managed or acted on by the Software, or b) uses the
            Software executables directly in an administrative, support, or User capacity. You must
            ensure that the Software is only used for the number of licenses purchased.
        </span>
        <br /> <br />
        <h4 class="section">Section 3. Beta and Trial Use</h4>
        <br />
        <span>
            Beta versions of the Software may contain bugs, errors, or other issues. Therefore, they
            may not be used in Your production environment(s) unless otherwise permitted
            by TransPerfect in writing. If TransPerfect provides You access to generally
            available Software for limited, temporary trial use, Your use is permitted for the period
            limited by the license key or by TransPerfect in writing. If there is no period identified,
            any trial use will expire thirty (30) days after the product is made available to You.
            Notwithstanding
            the foregoing, TransPerfect, in its discretion, may end the beta or trial at any time, at
            which point You will no longer have access to any related data, information, and files and
            You should immediately cease any further use. Furthermore, beta and trial products are
            provided “AS-IS” without support or any express or implied warranty or indemnity for any
            problems or issues, and TransPerfect will not have any liability relating to Your use of such
            Software.
        </span>
        <br /> <br />
        <h4 class="section">Section 4. Ownership</h4>
        <br />
        <span>
            The Software is protected by United States, Canadian, and international copyright laws.
            Title and copyright to the Software and accompanying documentation is owned by
            TransPerfect or its partners. TransPerfect or its partners retain exclusive ownership in all
            intellectual property rights in and to the Content and Software and all underlying
            technology and associated Documentation related thereto, and reserves all rights, title,
            and interest therein, as well as in any Derivative Works. You authorize TransPerfect to use
            any feedback and ideas You provide in connection with Your use of the Software for any
            purpose. The Software, including its object code and source code, whether or not
            provided to You, is Confidential Information of TransPerfect. You may not exercise any
            right, title, and interest in and to the Content, Software Documentation or any related
            intellectual property rights, except for the limited usage rights granted in this EULA. You
            agree, on behalf of Yourself and Your affiliates, that You and Your affiliates will take no
            action inconsistent with TransPerfect’s and its partners’ intellectual property rights. This
            EULA is not an agreement of sale, and does not transfer any title, intellectual property
            rights, or ownership rights to the Content, Software, or Documentation to You. You
            acknowledge and agree that the Content, Software, Documentation and all ideas,
            methods, algorithms, formulae, processes, and concepts used in developing or
            incorporated into the Content, Software, or Documentation, all future Upgrades, and all
            other improvements, revisions, corrections, bug fixes, hot fixes, patches, modifications,
            enhancements, releases, DATs, signature sets, upgrades, and policy and database updates
            and other updates in, of, or to the Content, Software, or Documentation, as applicable, all
            Derivative Works based on any of the foregoing, and all copies of the foregoing are trade
            secrets and proprietary property of TransPerfect or its partners, having great commercial
            value to TransPerfect and its partners.
        </span>
        <br /> <br />
        <h4 class="section">Section 5. Limitations and Restrictions</h4>
        <br />
        <span>
            Unless expressly authorized by TransPerfect in writing or otherwise permitted under
            applicable law, You will not: (a) sell, resell, transfer, sublicense, or assign Your rights under
            this license (except as expressly provided herein); (b) modify, adapt or create Derivative
            Works of the Software or Documentation; (c) reverse engineer, decompile, decrypt,
            disassemble, or otherwise attempt to derive the source code; (d) make the functionality
            available to third parties, whether as an application service provider, or on an
            outsourcing, membership or subscription, rental, service bureau, cloud service, managed
            or hosted service, or other similar basis; (e) use Software that is licensed for a specific
            device, whether physical or virtual, on another device; (f) remove, modify, or conceal
            any product identification, copyright, proprietary, intellectual property notices, or other
            marks; (g) use the Content with third-party products or service offerings that
            TransPerfect has not identified as compatible with the Software, extract Content or
            provide Content to a third party; (h) combine or merge any part of the Software or
            Documentation with or into any other software or documentation, except as provided in
            Section 18 below; (i) refer to or otherwise use the Software as part of any effort to develop
            software (including any routine, script, code, or program) having any functional attributes,
            visual expressions, or other features similar to those of the Software, or (j) run or operate
            the Software in a cloud, internet-based computing or similar on-demand computing
            environment unless TransPerfect specifically allows such use.
        </span>
        <br /> <br />
        <h4 class="section">Section 6. Upgrades and Additional Copies</h4>
        <br />
        <span>
            You may not use Upgrades or additional copies of the Software unless You have and
            comply with a valid license to the Software and have paid any fee applicable to the
            Upgrade or additional copies.
        </span>
        <br /> <br />
        <h4 class="section">Section 7. Use by Authorized Users</h4>
        <br />
        <span>
            You may allow Authorized Users to use the Software solely on Your behalf for Your
            internal operations. You are responsible for ensuring that Authorized Users comply with
            the terms of this EULA and You are liable for any breach of the same by such Authorized
            Users. To the extent permitted by applicable law, You must ensure that third parties using
            the Software on Your behalf bring all claims related to the Software through You and
            waive all claims directly against TransPerfect related to those claims.
        </span>
        <br /> <br />
        <h4 class="section">Section 8. Third-Party Products</h4>
        <br />
        <span>
            If You use the Software in conjunction with third-party products, You are responsible for
            complying with the third-party providers’ terms and conditions and privacy policies, and
            all such use is at Your risk. TransPerfect does not provide support or guarantee ongoing
            integration support for products that are not a native part of the Software.
        </span>
        <br /> <br />
        <h4 class="section">Section 9. Limited Warranty and Disclaimer</h4>
        <br />
        <span>
            <span class="bold">A. Limited Warranty.</span> TransPerfect warrants that the Software will substantially
            conform to the applicable Documentation for ninety (90) days following the date the Software
            is made available to You for Your use. This warranty does not apply if the Software,
            TransPerfect product, or any other equipment upon which the Software is authorized
            to be used: (i) has been altered, except by TransPerfect or its authorized
            representative; (ii) has not been installed, operated, repaired, or maintained in
            accordance with instructions supplied by TransPerfect; (iii) has been subjected to
            abnormal physical or electrical stress, abnormal environmental conditions, misuse,
            negligence, or accident; (iv) is licensed for beta or trial purposes; or (v) has not been
            provided by TransPerfect. TransPerfect will use commercially reasonable efforts to
            deliver to You Software free from any viruses, programs, or programming devices
            designed to modify, delete, damage, or disable the Software or Your data. YOU
            EXPRESSLY ACKNOWLEDGE AND AGREE THAT USE OF THE SOFTWARE IS AT YOUR
            SOLE RISK. TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, THE
            SOFTWARE AND ANY SERVICES PERFORMED OR PROVIDED BY THE SOFTWARE ARE
            PROVIDED "AS IS" AND “AS AVAILABLE,” WITH ALL FAULTS AND WITHOUT
            WARRANTY OF ANY KIND, AND TRANSPERFECT HEREBY DISCLAIMS ALL
            WARRANTIES AND CONDITIONS WITH RESPECT TO THE SOFTWARE AND ANY
            SERVICES, WHETHER EXPRESS, IMPLIED, OR STATUTORY, INCLUDING, BUT NOT
            LIMITED TO, THE IMPLIED WARRANTIES AND/OR CONDITIONS OF MERCHANTABILITY,
            OF SATISFACTORY QUALITY, OF FITNESS FOR A PARTICULAR PURPOSE, OF
            ACCURACY, OF QUIET ENJOYMENT, AND OF NONINFRINGEMENT OF THIRD-PARTY
            RIGHTS. NO ORAL OR WRITTEN INFORMATION OR ADVICE GIVEN BY TRANSPERFECT
            OR ITS AUTHORIZED REPRESENTATIVE SHALL CREATE A WARRANTY. SHOULD THE
            SOFTWARE OR SERVICES PROVE DEFECTIVE, YOU ASSUME THE ENTIRE COST OF ALL
            NECESSARY SERVICING, REPAIR, OR CORRECTION. SOME JURISDICTIONS DO NOT
            ALLOW THE EXCLUSION OF IMPLIED WARRANTIES OR LIMITATIONS ON APPLICABLE
            STATUTORY RIGHTS, SO THE ABOVE EXCLUSION AND LIMITATIONS MAY NOT APPLY
            TO YOU.
            <br /> <br />
            <span class="bold">B. Exclusive Remedy.</span> Upon Your prompt written notification to TransPerfect during
            the warranty period of TransPerfect’s breach of this Section 9, to the extent permitted by
            applicable law, Your sole and exclusive remedy is, at our option, either: (i) repair or
            replacement of the Software; or (ii) a refund of the license fees paid for the non-
            conforming Software. TransPerfect may ask You to return or destroy the Software
            and/or Documentation as a condition of the Software remedy.
            <br /> <br />
            <span class="bold">C. Exclusion of Warranty.</span> The Limited Warranty set forth herein will not apply if:
            (i) the Software is not used in accordance with this EULA or the Documentation; (ii) the
            Software or any part thereof has been modified by any entity other than TransPerfect;
            or (iii) a malfunction in the Software has been caused by any equipment or software
            not supplied by TransPerfect.
            <br /> <br />
            <span class="bold">D. High Risk Systems Terms.</span> THE SOFTWARE MAY FAIL AND IS NOT DESIGNED,
            DEVELOPED, TESTED, OR INTENDED TO BE RELIABLE IN THE CONTEXT OF HIGH-
            RISK SYSTEMS. TRANSPERFECT HAS NO RESPONSIBILITY FOR, AND YOU WILL
            INDEMNIFY AND HOLD HARMLESS TRANSPERFECT FROM, ALL CLAIMS, SUITS,
            DEMANDS, AND PROCEEDINGS ALLEGING, CLAIMING, SEEKING, OR ASSERTING
            ANY LIABILITY, LOSS, OBLIGATION, RISK, COST, DAMAGE, AWARD, PENALTY,
            SETTLEMENT, JUDGMENT, FINE, OR EXPENSES (INCLUDING ATTORNEY FEES)
            ARISING FROM OR IN CONNECTION WITH YOUR USE OF THE SOFTWARE ON OR
            IN A HIGH RISK SYSTEM, INCLUDING THOSE THAT COULD HAVE BEEN PREVENTED
            BY DEPLOYMENT OF FAIL-SAFE OR FAULT-TOLERANT FEATURES TO THE HIGH
            RISK SYSTEM, OR ARE BASED ON A CLAIM, ALLEGATION, OR ASSERTION THAT
            THE FUNCTIONING OF HIGH RISK SYSTEM DEPENDS OR DEPENDED ON THE
            FUNCTIONING OF THE SOFTWARE, OR THAT THE FAILURE OF THE SOFTWARE
            CAUSED A HIGH RISK SYSTEM TO FAIL.
            <br /> <br />
            <span class="bold">E. Third Parties.</span> The Software may contain independent third-party products and
            rely on them to perform certain functionality, including malware definitions or URL filters
            and algorithms. TransPerfect makes no warranty as to the operation of any third-party
            products or the accuracy of any third-party information.
        </span>
        <br /> <br />
        <h4 class="section">Section 10. Limitations and Exclusions of Liability</h4>
        <br />
        <span class="bold">
            In no event will TransPerfect or its licensors be liable for the following, regardless of
            the theory of liability or whether relating to or arising out of this EULA, Your Order,
            the Software, or otherwise, even if a party has been advised of the possibility of such
            damages: (i) indirect, incidental, exemplary, punitive, special, or consequential
            damages; (ii) loss or corruption of data or interrupted or loss of business; or (iii) loss
            of revenue, profits, goodwill, or anticipated sales or savings. All liability of
            TransPerfect, its affiliates, officers, directors, employees, agents, suppliers, and
            licensors collectively, to You, whether based in warranty, contract, tort (including
            negligence), or otherwise, shall not exceed, in the aggregate, the total fees
            attributable to the twelve (12) month period before the initial claim and paid or
            payable by You under the applicable Order. This limitation of liability for Software is
            cumulative and not per incident. Nothing in this EULA limits or excludes any liability
            that cannot be limited or excluded under applicable law.
        </span>
        <br /> <br />
        <h4 class="section">Section 11. Audit</h4>
        <br />
        <span>
            During the license term for the Software and for a period of three (3) years after its
            expiration or termination, You will take reasonable steps to maintain complete and
            accurate records of Your use of the Software sufficient to verify compliance with this
            EULA. No more than once per twelve (12) month period, You will allow TransPerfect and
            its auditors the right to examine such records and any applicable books, systems
            (including TransPerfect product(s) or other equipment), and accounts, upon reasonable
            advanced notice, during Your normal business hours. If the audit discloses underpayment
            of license fees, You will pay such fees plus the reasonable cost of the audit within thirty
            (30) days of receipt of written notice.
        </span>
        <br /> <br />
        <h4 class="section">Section 12. Term and Termination</h4>
        <br />
        <span>
            A. Your license begins on the date the Software is shipped or made available for
            download, access, or installation and continues until terminated or until the end of
            the term specified in the Order. This is also the start date of Your subscription, if the
            Software is licensed on a subscription basis.
            <br /> <br />
            <span class="bold">
                B. Subscriptions will automatically renew for the renewal period selected on the
                Order (“Renewal Term”) unless: (i) You notify TransPerfect in writing at least
                thirty (30) days before the end of the then-current term of Your intention not to
                renew; or (ii) You elect on the Order at the time of initial purchase not to auto-
                renew the subscription. TransPerfect will notify You reasonably in advance of any
                Renewal Term if there are fee changes. The new fees will apply for the upcoming
                Renewal Term unless You promptly notify TransPerfect in writing, before the
                applicable renewal date, that You do not accept the fee changes. In such event,
                the subscription will terminate at the end of the initial term.
            </span>
            <br /> <br />
            C. If a party materially breaches this EULA and does not cure that breach within thirty
            (30) days after receipt of written notice of the breach, the non-breaching party may
            terminate this EULA for cause. TransPerfect also has the right to immediately suspend
            or terminate Your use of the Software and/or Cloud Service if You breach Sections 2,
            4, 5, 7, 11, 13, 14, or 16. Upon termination of the EULA, You must cease any further use
            of the Software and destroy any copies of Software within Your control. Upon Your
            termination for TransPerfect’s material breach of the EULA, if there are any
            outstanding subscriptions we will refund to You any prepaid fees covering the period
            from the effective date of termination to the end of the term. Upon TransPerfect’s
            termination for Your material breach of the EULA, if there are any outstanding
            subscriptions You will pay TransPerfect any unpaid fees covering the period from the
            effective date of termination to the end of the term.
        </span>
        <br /> <br />
        <h4 class="section">Section 13. Confidential Information and Data</h4>
        <br />
        <span>
            <span class="bold">A. Confidential Information.</span> You will hold in confidence and use no less than
            reasonable care to avoid disclosure of any Confidential Information to any third party,
            except for Your employees, affiliates, and contractors who have a need to know such
            information in connection with this EULA, and are under written confidentiality
            obligations no less restrictive than the terms set forth in this Section. You will be liable
            for any breach of this Section by Your employees, affiliates, and contractors. Your
            nondisclosure obligation will not apply to information which: (i) is known by You
            without confidentiality obligations; (ii) is or has become public knowledge through no
            fault of Your own; or (iii) is independently developed by You. You may disclose
            TransPerfect’s Confidential Information if required pursuant to a regulation, law, or
            court order; provided that, You provide prior notice to TransPerfect (to the extent
            legally permissible) and reasonably cooperate, at TransPerfect’s expense, regarding
            protective actions pursued by TransPerfect. Upon reasonable request of TransPerfect,
            You will either return, delete, or destroy all Confidential Information of TransPerfect
            and certify the same.
            <br /> <br />
            <span class="bold">B. How We Use Your Data.</span> TransPerfect processes and uses Personal Data and
            Customer Data to deliver, analyze, support, and improve the Software and as otherwise
            permitted in this EULA and TransPerfect’s privacy policy
            (https://www.transperfect.com/about/privacy.html). TransPerfect will maintain
            appropriate administrative, physical, and technical safeguards, which are designed to
            protect the security, confidentiality, and integrity of Personal Data and Customer
            Data processed by TransPerfect. TransPerfect may share Personal Data and
            Customer Data with third-party service providers consistent with TransPerfect’s
            Privacy Statement in order to assist in providing and improving the Software.
            <br /> <br />
            <span class="bold">C. Telemetry Data.</span> TransPerfect processes Telemetry Data to deliver, enhance,
            improve, customize, support, and/or analyze the Software and other TransPerfect offerings and
            otherwise may freely use Telemetry Data that does not identify You or any of Your
            Authorized Users.
            <br /> <br />
            <span class="bold">D. International Data Transfers.</span> TransPerfect may process and store Customer Data
            and Personal Data in the United States or outside of the country where it was collected.
            You are responsible for providing any required notices to Authorized Users and
            obtaining all required consents from Authorized Users regarding the processing and
            transfer of Personal Data by the Software, including international transfers.
            TransPerfect will only transfer Personal Data consistent with applicable law. To the
            extent TransPerfect processes any Personal Data from the European Economic Area
            or Switzerland on Your behalf, we will do so in a manner consistent with applicable
            privacy laws. Where TransPerfect transfers Personal Data from an APEC Member
            Economy on behalf of You, TransPerfect will process such Personal Data in a manner
            consistent with the APEC Cross Border Privacy Rules Systems requirements
            (“CBPRs”) (see www.cbprs.org) to the extent the requirements are applicable to
            TransPerfect’s processing of such data. If TransPerfect is unable to provide at least the
            same level of protection as required by the Principles or CBPRs, TransPerfect will
            promptly notify You and cease processing. You are responsible for providing any
            required notices to Authorized Users and obtaining all required consents from
            Authorized Users regarding the processing and transfer of such Authorized Users’
            Personal Data by the Software, including international transfers.
        </span>
        <br /> <br />
        <h4 class="section">Section 14. Indemnification</h4>
        <br />
        <span>
            <span class="bold">A. Your Indemnification Obligations.</span> You will unconditionally indemnify and defend
            TransPerfect, its affiliates, and their officers, directors, employees, contractors, and
            agents (each a TransPerfect indemnified party) against any claims, liabilities, and
            expenses (including court costs and reasonable attorney fees) that a TransPerfect
            indemnified party incurs as a result of or in connection with any claims arising from: (i)
            Your failure to obtain any consent, authorization, or license required for TransPerfect’s
            use of data, software, materials, systems, networks, or other technology provided by
            You under this EULA or any Order; (ii) Your use of the Software in a manner not
            expressly permitted by this EULA; (iii) TransPerfect’s compliance with any technology,
            designs, instructions, or requirements provided by You or a third party on Your behalf;
            (iv) any claims, costs, damages, and liabilities whatsoever asserted by any of Your
            representatives; (v) any violation by You of applicable laws; and (vi) any reasonable
            costs and attorneys’ fees required for TransPerfect to respond to a subpoena, court
            order, or other official government inquiry regarding Your use of the Software.
            <br /> <br />
            <span class="bold">B. TransPerfect Indemnification Obligations.</span> (i) TransPerfect will indemnify You
            and, at TransPerfect’s election, defend You against a third-party claim asserted against You in
            a suit or action if the claim is for direct patent infringement, for direct copyright
            infringement, or for TransPerfect’s trade secret misappropriation, and the claim is
            asserted against the Software alone and not in combination with anything else, or solely
            a combination of TransPerfect products. (ii) <span class="bold">Exclusions:</span> Notwithstanding anything
            to the contrary in this EULA, TransPerfect will not indemnify or defend You for claims
            asserted, in whole or in part, against: (x) technology. designs or requirements that You
            gave to TransPerfect; or (y) modifications or programming to Software that were made
            by anyone other than TransPerfect. (iii) <span class="bold">Remedies:</span> TransPerfect may, in its sole
            discretion and at its own expense, with respect to any Software that is subject to a
            claim: (w) procure You the right to continue using the Software; (x) replace the
            Software with a non-infringing Software; (y) modify the Software so that it becomes
            non-infringing; or (z) upon Your return of the Software to TransPerfect and removal of
            the Software from Your systems, refund the residual value of the purchase price You
            paid for the infringing Software, depreciated using a straight-line method of
            depreciation over a three (3) year period from the date of delivery of the Software to
            You.
            <br /> <br />
            <span class="bold">C. Indemnification Procedure.</span> The indemnified party (“Indemnitee”) will: (i)
            provide prompt written notice to the indemnifying party (“Indemnitor”) of the claim (provided
            that the failure to provide timely notice that prejudices the Indemnitor will relieve the
            Indemnitor of its obligations under this section to the extent the Indemnitor has been
            prejudiced and the failure to provide timely notice will relieve the Indemnitor of any
            obligation to reimburse the Indemnitee for its attorney’s fees incurred prior to
            notification); (ii) reasonably cooperate in connection with the defense or settlement of
            the claim; and (iii) give the Indemnitor sole control over the defense and settlement of
            the claim, provided that any settlement of a claim will not include a specific
            performance obligation or admission of liability by the Indemnitee.
            <br /> <br />
            <span class="bold">D. Personal and Exclusive Indemnity.</span> The foregoing indemnities are personal to the
            parties and may not be transferred anyone. This section states the parties’ entire
            indemnification obligations and Your exclusive remedy claims involving intellectual
            property rights.
        </span>
        <br /> <br />
        <h4 class="section">Section 15. US Government End Users</h4>
        <br />
        <span>
            The Software and Documentation are deemed to be “commercial computer software”
            and “commercial computer software documentation” pursuant to FAR 12.212 and DFARS
            227.7202. All US government end users acquire the Software and Documentation with
            only those rights set forth in this EULA. Any provisions that are inconsistent with federal
            procurement regulations are not enforceable against the US government.
        </span>
        <br /> <br />
        <h4 class="section">Section 16. Export</h4>
        <br />
        <span>
            The Software, products, technology, and services are subject to US and local export
            control laws and regulations. You and TransPerfect each will comply with such laws and
            regulations governing use, export, re-export, and transfer of Software, products, and
            technology and will obtain all required US and local authorizations, permits, or licenses.
            You may not use or otherwise export or re-export the Software except as authorized by US
            laws and the laws of the jurisdiction in which the Software was obtained. In particular, but
            without limitation, the Software may not be exported or re-exported (a) into any US-
            embargoed countries or (b) to anyone on the US Treasury Department's Specially Designated
            Nationals List or the US Department of Commerce Denied Persons List or Entity List. By using
            the Software, you represent and warrant that you are not located in any such country or on
            any such list. You also agree that you will not use these products for any purposes prohibited
            by United States law, including, without limitation, the development, design, manufacture, or
            production of nuclear, missile, or chemical or biological weapons.
        </span>
        <br /> <br />
        <h4 class="section">Section 17. Survival</h4>
        <br />
        <span>
            Sections 4, 5, 9, 10, 11, 13-17, 19-23, and 25 shall survive termination or expiration of this EULA.
        </span>
        <br /> <br />
        <h4 class="section">Section 18. Interoperability</h4>
        <br />
        <span>
            If required by applicable law, TransPerfect will provide You with the interface information
            needed to achieve interoperability between the Software and another independently
            created program. TransPerfect will provide this interface information at Your written
            request. You will keep this information in strict confidence and strictly follow any
            applicable terms and conditions upon which TransPerfect makes such information
            available.
        </span>
        <br /> <br />
        <h4 class="section">Section 19. Third-Party Beneficiaries</h4>
        <br />
        <span>
            This EULA does not grant any benefits to any third party unless it expressly states that it
            does. In particular, no person other than a party to the EULA can enforce or take the
            benefit of any of its terms under the Contracts (Rights of Third Parties) Act 1999.
        </span>
        <br /> <br />
        <h4 class="section">Section 20. Governing Law and Arbitration</h4>
        <br />
        <span>
            This EULA, and any disputes arising out of or related hereto, will be governed exclusively
            by the laws of the State of New York, USA, and without regard to conflicts of laws rules. The
            application of the United Nations Convention on the International Sale of Goods is
            expressly excluded. Any dispute between the parties arising out of, or relating to, the
            validity, construction, interpretation, or performance of this EULA that cannot be
            resolved amicably shall be submitted to binding and confidential arbitration. The seat
            of such arbitration proceedings shall be in the Borough of Manhattan, County and
            State of New York, USA, and such proceedings shall, except as specifically provided
            herein, be conducted in accordance with the rules of the Comprehensive Arbitration
            Rules of JAMS, Inc. ("JAMS"). Any such arbitration proceeding shall be conducted
            before three (3) JAMS arbitrators, with one arbitrator each selected by the parties
            and the third to be selected by the first two arbitrators, unless the parties otherwise
            agree to a single arbitrator, in which event such single arbitrator shall be selected by
            agreement of the parties in their reasonable discretion. The parties agree to
            cooperate with each other and JAMS to select the arbitrator(s) within two (2) weeks
            after the filing of the arbitration demand. The party filing the arbitration demand shall
            be required to attach a statement of claim to such demand, including all documentary
            evidence being relied on. Depositions shall be permitted but neither party shall be
            permitted to demand more than three (3) depositions. The arbitrator(s) shall have the
            authority to issue subpoenas unless prohibited by law. The arbitrator(s) shall not have
            the authority to award punitive damages or attorneys’ fees, costs, or expenses. The
            decision and award of the arbitrator(s) shall be final and binding upon the parties and
            may be enforced in any court of competent jurisdiction. The parties agree that the
            Federal Arbitration Act shall apply with respect to any award rendered by the
            arbitrator(s). The parties shall share equally the cost of the arbitration. Either party
            may obtain interim injunctive relief in any court of appropriate jurisdiction with respect
            to any alleged breach of intellectual property or proprietary rights without the necessity
            of posting a bond or other security or of proving damages.
            <br /> <br />
            If You are a public sector agency or government institution located in the United States,
            the laws of the primary jurisdiction in which You are located will govern the EULA and any
            disputes arising out of or related thereto. For US federal government customers, this
            EULA shall be controlled and construed under the laws of the United States of America.
        </span>
        <br /> <br />
        <h4 class="section">Section 21. Integration</h4>
        <br />
        <span>
            If any portion of this EULA is found to be void or unenforceable, the remaining provisions
            of this EULA shall remain in full force and effect. Except as expressly stated or as expressly
            amended in a signed agreement, this EULA is the complete agreement between the parties
            with respect to the Software and supersedes all prior or contemporaneous
            communications, understandings, or agreements (whether written or oral) regarding this
            subject matter. In the event of any conflict, the order of precedence is: (i) this EULA
            and (ii) the applicable Order. The parties agree that the English version of the EULA
            will govern in the event of a conflict between it and any version translated into another
            language. TransPerfect and the TransPerfect logo are trademarks or registered
            trademarks of TransPerfect and/or its affiliates in the US and other countries.
        </span>
        <br /> <br />
        <h4 class="section">Section 22. General Provisions</h4>
        <br />
        <span>
            <span class="bold">A. Relationship.</span> The parties are independent contractors under this EULA and
            expressly disclaim any partnership, franchise, joint venture, agency, employer/employee,
            fiduciary, or other special relationship. Neither party intends this EULA to benefit or
            create any right or cause of action in or on behalf of any person or entity other than
            the parties. This EULA is not intended to create a third-party beneficiary of any kind.
            You must not represent to any third party that it has any right to bind TransPerfect in
            any manner and You will not to make any representations or warranties on behalf of
            TransPerfect.
            <br /> <br />
            <span class="bold">B. Severability.</span> If a court holds that any provision of this EULA is invalid or
            unenforceable under applicable law, the court will modify the provision to the minimum extent
            necessary to make it valid and enforceable or, if it cannot be made valid and
            enforceable, the court will sever and delete the provision from this EULA. The change
            will affect neither the validity of the amended provision nor the validity of any other
            provision of this EULA, which will continue in full force and effect.
            <br /> <br />
            <span class="bold">C. Assignment.</span> You may not sublicense, assign, or transfer Your rights under this
            EULA without TransPerfect’s prior written consent. Any attempt by You to sublicense,
            assign, or transfer any of Your rights, duties, or obligations under this EULA, whether
            directly, or indirectly by merger, acquisition, or change of control, will be null and void.
        </span>
        <br /> <br />
        <h4 class="section">Section 23. Notification</h4>
        <br />
        <span>
            TransPerfect may provide You with notice via email, regular mail and/or postings on the
            TransPerfect.com website or any other website used with the Software. Notices to
            TransPerfect should be sent to TransPerfect, Office of General Counsel, 1250 Broadway,
            New York, NY 10001 unless this EULA, applicable supplemental terms, or an Order
            specifically allows other means of notice.
        </span>
        <br /> <br />
        <h4 class="section">Section 24. Force Majeure</h4>
        <br />
        <span>
            Except for payment obligations, neither party will be responsible for failure of
            performance due to an event beyond the affected party’s reasonable control, including
            accidents, severe weather events, acts of God, actions of any government agency,
            pandemic, acts of terrorism, or the stability or availability of the internet or portions
            thereof.
        </span>
        <br /> <br />
        <h4 class="section">Section 25. Reservation of Rights, Subcontracting, and Modifications</h4>
        <br />
        <span>
            Failure to enforce any right under this EULA will not waive that right.
        </span>
        <br /> <br />
        <h4 class="section">Section 26. Definitions</h4>
        <br />
        <span>
            <span class="bold">“Authorized User(s)”</span> means the individuals You authorize to access the Software,
            including Your employees or third parties that access the Software solely on Your behalf
            for Your internal operations.
            <br /> <br />
            <span class="bold">“Cloud Service”</span> means the TransPerfect hosted software-as-a-service offering or
            other TransPerfect cloud-enabled feature described in an Order.
            <br /> <br />
            <span class="bold">“Confidential Information”</span> means non-public proprietary information of
            TransPerfect obtained by You in connection with this EULA, which: (i) is conspicuously marked; or, (ii)
            if verbally disclosed, is summarized in writing to You within 14 days; or (iii) is information
            not so marked or summarized but which by its nature or given the circumstances of its
            disclosure should reasonably be considered confidential. You agree all information
            regarding the pricing, functionality, and performance of the Software is Confidential
            Information and cannot be used for any purpose not authorized herein or disclosed to any
            third party without written consent of TransPerfect.
            <br /> <br />
            <span class="bold">“Content”</span> means any TransPerfect-provided content or data, including, but not
            limited to, geographic or domain information, rules, signatures, threat intelligence or other threat
            data feeds, suspicious URLs, and IP address data feeds.
            <br /> <br />
            <span class="bold">“Customer Data”</span> means all information and data that You or an Authorized User
            provides or transfers to TransPerfect or that the Software collects from You, Your Authorized
            User(s), or Your system(s), in connection with Your use of the Software, including but not
            limited to data related to those Authorized Users. Customer Data does not include
            Telemetry Data.
            <br /> <br />
            <span class="bold">“Derivative Work”</span> means a work that is based on one or more preexisting works
            (such as a revision, translation, dramatization, motion picture version, abridgment,
            condensation, enhancement, modification, or any other form in which preexisting work
            may be recast, transformed or adapted) which, if created without the authorization of the
            copyright owner of the preexisting work, would constitute copyright infringement.
            <br /> <br />
            <span class="bold">“Documentation”</span> means the TransPerfect user or technical manuals, training
            materials, specifications, privacy data sheets, or other information applicable to the Software.
            <br /> <br />
            <span class="bold">“Order”</span> means an ordering document (including a web or other electronic form) that
            specifies the duration, type, and quantity of Software to be provided and the associated
            fees (if relevant).
            <br /> <br />
            <span class="bold">“Personal Data”</span> means any information that can be used to identify an individual
            and may include name, address, email address, phone number, login information (account
            number and password), marketing preferences, social media account information, or
            payment card number.
            <br /> <br />
            <span class="bold">“Software”</span> means the binary image of TransPerfect computer programs (including
            Upgrades), which could be a downloadable file, delivered on physical media, pre-installed
            on the on-premise computer system, resident in ROM/Flash (system memory) or cloud-
            hosted, and purchased or licensed from TransPerfect, including Reef ECA.
            <br /> <br />
            <span class="bold">“Telemetry Data”</span> means all information and data that the Software generates in
            connection with Your use, including but not limited to, network policy, log and
            configuration information; threat intelligence data, URLs, metadata, or net flow data;
            origin and nature of malware; the types of software or applications installed on a network
            or an endpoint; information about the devices connected to a network; information
            generated by sensors, devices, and machinery; information related to the usage, origin of
            use, traffic patterns, or behavior of the users of a network or Software; and information
            relating to the existence of cookies, web beacons, and other similar applications.
            <br /> <br />
            <span class="bold">“TransPerfect,” “we,” “our,” or “us”</span> means TransPerfect Translations International
            Inc. or its applicable affiliate(s).
            <br /> <br />
            <span class="bold">“Upgrades”</span> means all updates, upgrades, bug fixes, error corrections,
            enhancements, and other modifications to the Software.
            <br /> <br />
            <span class="bold">“You”</span> and <span class="bold">“Your”</span> means the individual or legal entity
            licensing the Software under this EULA.
        </span>
        <br /> <br />
        <h4 class="section">Section 27. Marketing, Publicity, and Branding</h4>
        <br />
        <span>
            <span class="bold">A. Press Release.</span> Client agrees that TransPerfect may issue a press release, at
            TransPerfect’s sole expense, announcing this relationship.
            <br /> <br />
            <span class="bold">B. Publicity Opportunities.</span> TransPerfect is permitted from time to time to seek
            publicity opportunities that represent a mutual benefit to both the Client and
            TransPerfect. These opportunities may include articles in newspapers or other public
            information sources, speaking engagements at conferences, and press briefings. The
            Client will have the opportunity to accept or decline participation in each individual
            opportunity.
            <br /> <br />
            <span class="bold">C. Name and Website.</span> TransPerfect shall have permission to list the Client’s
            company name, logo, and website link within a list or collection of companies using the
            Software.
            <br /> <br />
            <span class="bold">D. Reference.</span> Client agrees to serve as a reference for TransPerfect and the
            Software on occasions where prospective and current TransPerfect clients may request to speak
            with other clients, provided that TransPerfect shall seek Client’s consent before
            referring any clients to Client.
        </span>
        <br />
    </div>

</res-base-modal>